@use "../../styling/colors.scss" as *;
@use "../../styling/form-controls.scss" as *;
@use "../../styling/typography.scss" as *;
@use "../../styling/buttons.scss" as *;

// Requirements when making changes:
// No extra space around the label can be clicked
// Reacts to keyboard focus
// Scales to fit long text

.InputFile {
  display: inline-flex;
  gap: 0.5em;

  >label {
    @extend %button;

    column-gap: 0;
    margin: 0 !important; // reset rule from extension

    // Make a single cell that contains both elements, so they overlap
    grid-column: 1/1;
    grid-row: 1/1;
    color: $color-white;
    background: $form-control-color;
    text-align: center;
    padding: 0;

    span {
      padding: 7px 16px;
    }
  }

  >span {
    @extend %font-family-primary;

    font-size: $font-size-normal;
    color: $color-grey-B;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // The real input
  >label input {
    // stow the real input behind the visual label
    z-index: -1;
    padding: 0;
    width: 1px;
    height: 1px;
    visibility: hidden;
  }

  &:hover,
  &:focus-within {
    label {
      background: $color-primary-purple-hover;
    }
  }
}